import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useUserType } from '@/hooks/useUserType';

/**
 * Landing redirect at `/app`. Sends organizers to /app/dashboard and guests
 * directly to their assigned event. Guests with no active access fall through
 * to /login.
 */
export const PostLoginRedirect: React.FC = () => {
  const { isGuest, accessibleEventId, loading } = useUserType();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (isGuest) {
    if (accessibleEventId) {
      return <Navigate to={`/app/events/${accessibleEventId}/guests`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/app/dashboard" replace />;
};
